/* Hub order form medicine box: official product names from the office list appear after 3 letters (no prices). */
import { useEffect, useRef, useState } from "react";
import { papi } from "./portalApi";

export const MedInput = ({ value, onChange, testid }) => {
  const [items, setItems] = useState([]);
  const [open, setOpen] = useState(false);
  const t = useRef(null);
  useEffect(() => {
    clearTimeout(t.current);
    if (!open || String(value || "").trim().length < 3) { setItems([]); return undefined; }
    t.current = setTimeout(() => papi("get", `/order-med-suggest?q=${encodeURIComponent(value.trim())}`).then((r) => setItems(r.items || [])).catch(() => setItems([])), 250);
    return () => clearTimeout(t.current);
  }, [value, open]);
  return (
    <div className="relative min-w-0 basis-full md:basis-auto md:flex-1">
      <input placeholder="Medicine — type 3 letters" value={value} autoComplete="off" onChange={(e) => { onChange(e.target.value); setOpen(true); }}
        onFocus={() => setOpen(true)} onBlur={() => setTimeout(() => setOpen(false), 200)} className="w-full rounded-lg border px-3 py-2 text-sm" data-testid={testid} />
      {open && items.length > 0 && (
        <div className="absolute left-0 top-full z-30 mt-1 max-h-64 w-full min-w-[260px] overflow-y-auto rounded-lg border bg-white text-xs shadow-xl" data-testid={`${testid}-suggest`}>
          {items.map((x, i) => (
            <button key={x.name} type="button" onMouseDown={(e) => e.preventDefault()} onClick={() => { onChange(x.name); setOpen(false); }}
              className="block w-full border-b px-3 py-1.5 text-left hover:bg-teal-50" data-testid={`${testid}-opt-${i}`}>
              <b className="block text-slate-800">{x.name}{x.fav && <span className="ml-1.5 rounded bg-amber-100 px-1 text-[9px] font-semibold text-amber-800" data-testid={`${testid}-fav-${i}`}>your usual · {x.fav}×</span>}</b>
              {(x.generic || x.packing) && <span className="text-[10px] text-slate-500">{[x.generic, x.packing && `Strip of ${x.packing}`].filter(Boolean).join(" · ")}</span>}
            </button>))}
        </div>)}
    </div>
  );
};
